/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc service
 * @name systemConfigService
 * @author Alex Malitsky
 * @description
 *
 *     Most often we need only one Item of systemConfig and this is it.
 */
angular.module('aviApp').service('systemConfigService', [
'$rootScope', 'SystemConfig',
function($rootScope, SystemConfig) {
    const systemConfig = new SystemConfig();

    //not every user has access to systemconfig, remove it to be on the safe side
    $rootScope.$on('setContext', systemConfig.emptyData.bind(systemConfig));

    return systemConfig;
}]);
